

function lazyPopover(elem, wistiaMediaId) {
	elem.addEventListener('click', function setupPopover() {
      
      //create script
      var scriptUrl = '//fast.wistia.com/assets/external/E-v1.js';
      if (isWistiaScriptLoaded(scriptUrl) != true) {      
     	  var ev1 = document.createElement('script');
          ev1.src = '//fast.wistia.com/assets/external/E-v1.js';
          ev1.async = true;
          ev1.charset = 'ISO-8859-1'
          document.head.appendChild(ev1); 
      }

      makeEmbedPop(elem, wistiaMediaId);
      elem.removeEventListener('click', setupPopover);
    	
	});
};

function isWistiaScriptLoaded(url) {
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length; i--;) {
        if (scripts[i].src == url) return true;
    }
    return false;
}


function makeEmbedPop(elem, mediaID) { 
	elem.setAttribute('class', 'wistia_embed wistia_async_' + mediaID + ' popover=true popoverContent=link');
	//Wistia.embeds.setup();
  var popoverAction = {};
  popoverAction[mediaID] = function(video) {
  	video.popover.show();
  	video.play();
  };
  window._wq = window._wq || [];
  _wq.push(popoverAction);
};


var wistiaVids = document.getElementsByName("wistia-video");

for (var i = 0; i < wistiaVids.length; i++){
	lazyPopover(wistiaVids[i], wistiaVids[i].getAttribute("data-embed"));

};


